import { render, staticRenderFns } from "./ContributorsPage.vue?vue&type=template&id=3a633330&"
import script from "./ContributorsPage.vue?vue&type=script&lang=js&"
export * from "./ContributorsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContributorsPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContributorsPage.vue"
export default component.exports